import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Button } from '@/components/ui/button';
import { Stack } from '@/components/ui/layout';
import { cn } from '@/lib/utils';

function SearchSection() {
  return (
    <Card className={cn("w-full")}>
      <CardContent className={cn("p-6")}>
        <form className={cn("space-y-4")}>
          <Stack spacing="md">
            <div className={cn("space-y-2")}>
              <Label htmlFor="email">Search By Email:</Label>
              <div className={cn("relative")}>
                <Input
                  type="email"
                  id="email"
                  name="email"
                  placeholder="Enter email address"
                  required
                  className={cn("pr-10")}
                />
                <img
                  loading="lazy"
                  src="https://cdn.builder.io/api/v1/image/assets/TEMP/fb24d7fe7b454963c437bc111d6e80930a040498c857814880d7140b39dd277b?placeholderIfAbsent=true&apiKey=7b6c1215e2f745adac7c4e4629a4a214"
                  alt="search icon"
                  className={cn("absolute right-3 top-1/2 -translate-y-1/2 w-5 h-5")}
                />
              </div>
            </div>

            <div className={cn("space-y-2")}>
              <Label htmlFor="experience">Experience Year:</Label>
              <Input
                type="number"
                id="experience"
                name="experience"
                placeholder="Enter years of experience"
                min="0"
                required
              />
            </div>

            <div className={cn("space-y-2")}>
              <Label htmlFor="skill">Enter Skill:</Label>
              <Input
                type="text"
                id="skill"
                name="skill"
                placeholder="Enter skill"
                required
              />
            </div>

            <Button type="submit" className={cn("w-full")}>Search</Button>
          </Stack>
        </form>
      </CardContent>
    </Card>
  );
}

export default SearchSection;
